var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section-wrapper w-100",
      attrs: { id: "other-properties-section-wrapper" },
    },
    [
      _vm._l(_vm.properties, function (property, propertyIndex) {
        return _c("property-owned", {
          key:
            "property-" +
            property.applicantIndex +
            "-" +
            propertyIndex +
            "-" +
            property.order +
            "-" +
            _vm.propId,
          staticClass: "other-properties-container",
          attrs: {
            id:
              _vm.getApplicantKey(property.applicantIndex) +
              "[other-properties][" +
              propertyIndex +
              "]",
            "array-index": propertyIndex,
            "applicant-key": _vm.getApplicantKey(property.applicantIndex),
            "applicant-index": parseInt(property.applicantIndex),
            applicant: _vm.getApplicantForProperty(property),
            "property-index": property.propertyIndex,
            property: _vm.getProperty(propertyIndex),
            "edit-visibility": _vm.editVisibility,
            "all-properties": _vm.properties,
            "applicant-select-options": _vm.applicantSelectOptions,
            "current-application": _vm.currentApplication,
            "is-main-applicant-screen": _vm.isMainApplicantScreen,
          },
          on: {
            "remove-property": function ($event) {
              return _vm.handleRemoveProperty(propertyIndex)
            },
            "change-ownership": function (applicantIndex) {
              return _vm.handlePropertyOwnership(applicantIndex, propertyIndex)
            },
            "page-change": _vm.handlePageChange,
            save: _vm.handleSave,
            "toggle-visibility": _vm.handleVisibility,
            replicate: function ($event) {
              return _vm.$emit("replicate")
            },
            "change-height": _vm.handleResize,
            "height-remove": _vm.handleHeightRemove,
          },
        })
      }),
      _vm._v(" "),
      !_vm.editVisibility
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 mb-0" }, [
              _c("div", { staticClass: "px-5" }, [
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 text-center need-additional-banner",
                    },
                    [
                      _c("h3", { staticClass: "bold" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("application.needToAddAdditional", {
                                additionalTarget: _vm.pluralizedPropertyName,
                              })
                            ) +
                            "?\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary d-md-inline d-block text-md-left text-center w-md-auto w-100",
                          attrs: {
                            type: "button",
                            disabled: _vm.coApplicantsDisabled,
                            tabindex: _vm.tabIndex(1200),
                          },
                          on: {
                            click: _vm.addProperty,
                            keypress: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.addProperty.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("application.addAdditional", {
                                  additionalTarget: _vm.$t(
                                    "application-form.property"
                                  ),
                                })
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }